import { useEffect, useMemo } from "react";
import { debounce } from "lodash";

export const useDebouncedSave = <Args extends unknown[]>(
  fn: (...args: Args) => void,
  delay = 300
) => {
  const debouncedFn = useMemo(() => debounce(fn, delay), [fn, delay]);

  useEffect(() => () => debouncedFn.cancel(), [debouncedFn]);

  return debouncedFn;
};
